<template>
  <div class="content">
    <van-image
      width="100vw"
      height="auto"
      :src="topImg"
    />
    <div class="form-box" v-if="!isBound">
      <van-form ref="formRef">
        <van-field
          v-model="form.mobileNo"
          name="mobileNo"
          type="digit"
          maxlength="11"
          placeholder="请输入手机号"
          :rules="[{ required: true, message: '手机号不能为空' }]"
        >
          <div class="left-icon-box" slot="left-icon">
            <img :src="icons.phone">
          </div>
        </van-field>
        <van-field
          v-model="form.code"
          type="digit"
          maxlength="6"
          name="code"
          left-icon="passed"
          placeholder="请输入验证码"
          autocomplete="off"
          :rules="[{ required: true, message: '验证码不能为空' }]"
        >
          <div class="left-icon-box" slot="left-icon">
            <img :src="icons.lock">
          </div>
          <van-button 
            class="code-btn"
            slot="button" 
            size="small" 
            plain
            color="#FF6B31" 
            :disabled="isCodeDisabled" 
            @click="getCode">{{ isCodeDisabled ? `${timeString} 秒` : timeString}}</van-button>
        </van-field>
        
      </van-form>
      <div class="btn-box">
        <van-button round block native-type="submit" class="block-btn" @click="onSubmit">提交</van-button>
      </div>
      <p class="tips-content">
        温馨提示：<br/>
        一、终端店面人员登录验证:<br />
        1.录入本人在TOP系统中的职员手机号(即登录账号);<br />
        2.在TOP系统中的职员档案-在职状态为“在职”状态;<br />
        二、公司内部人员登录验证:<br />
        1.与YOYO365打卡系统登录手机号一致(若记不住号码或调整预留手机号，请联系部门文控协助查询或调整);<br />
        2.若本人手机号与某门店员工手机号验证重复，默认为公司内部人员权限.
      </p>
    </div>
    <div class="success-box" v-else>
      <div class="info-box">
        <van-icon name="passed" color="#FF6B31" size="50" />
        <div>绑定成功</div>
      </div>
      <div class="btn-box">
        <van-button round block native-type="button" class="block-btn" @click="goHome(true)">返回首页</van-button>
      </div>
    </div>
    
  </div>
</template>

<script>
import store from '@/store'
const COUNTDOWN_TIME = 120;
import loadingMixin from '@/mixins/loading-mixin'
export default {
  name: 'Binding',
  mixins: [loadingMixin],
  data() {
    return {
      topImg: require('@/assets/images/bind.png'),
      icons: {
        phone: require('@/assets/icons/login_phone.png'),
        lock: require('@/assets/icons/login_lock.png')
      },
      // 是否绑定成功
      isBound: false,
      form: {
        mobileNo: '',
        code: ''
      },
      timeString: '获取验证码',
      isCodeDisabled: false,
      timer: null,
      loading: null,
      isFirst: true,
      id: ''
    };
  },
  created() {
    // 判断组件是否有缓存
    if (this.$vnode && this.$vnode.data.keepAlive) {
      return;
    } else {
      // 阻止H5自带返回键返回
      this.prevent_back();
    }
  },
  methods: {
    async getCode() {
      if (!this.form.mobileNo) {
        return;
      }
      // 检查手机号是否是系统内预留
      const checkRes = await this.$api.common.checkPhoneNumExisted(this.form.mobileNo);
      if (!checkRes || !checkRes.success) {
        return;
      }
      this.$api.common.sendSMSCode(this.form.mobileNo)
        .then(() => {
          this.startCountdown();
        });
    },
    startCountdown() {
      this.timeString = COUNTDOWN_TIME;
      this.countDown();
    },
    countDown() {
      this.isCodeDisabled = true
      this.timeString = this.timeString - 1
      if (this.timeString <= 0) {
        this.timeString = '获取验证码'
        this.isCodeDisabled = false
        return
      }
      this.timer = setTimeout(this.countDown, 1000)
    },
    onSubmit() {
      this.$refs.formRef.validate()
        .then(() => {
          this.showLoading();
          const loginInfo = this.$cache.getLoginInfo();
          const params = {
            ...this.form,
            openId: loginInfo && loginInfo.openId,
            unionId: loginInfo && loginInfo.unionid
          };
          this.$api.common.bindMobile(params)
            .then((res) => {
              // 更新缓存的绑定状态
              this.$cache.setBindingState(true);
              loginInfo.telephoneMd5 = res.data
              this.$cache.setLoginInfo(loginInfo);
              // if (!loginInfo.telephoneMd5) {
              //   loginInfo.telephoneMd5 = res.data
              //   this.$cache.setLoginInfo(loginInfo);
              // }
              this.getLoginUserList(loginInfo.telephoneMd5, false)
            }).catch(_=> {
              this.hideLoading();
            })
            // .finally(_ => {
            //   this.hideLoading();
            // });
        });
    },
    getLoginUserList(telephoneMd5) {
      this.$api.common.getLoginUserList({telephoneMd5})
        .then(res => {
          this.$cache.setLoginUserList(res.data || [])
          if (res.data.length > 1) {
            this.$router.replace({ path: '/role-change' });
          }else {
            this.id = res.data[0].id
            this.goHome(false)
          }
        }).finally(_=>{
          this.hideLoading();
        })
    },
    goHome(type) {
      if (this.isFirst) {
        this.isFirst = false
        this.showLoading();
        let params = {
          userId: this.id,
          wxToken: this.$cache.getLoginInfo().wxToken,
          flag: this.$cache.is365() ? 2 : 1
        }
        this.$api.common.confirmLoginUser(params)
          .then( async res => {
            const department = await this.$api.h5.userSaleShopInfo()
            if (department.data.length <= 1) {
              await store.dispatch("getUserInfo");
              if (type) {
                this.$router.replace({ path: '/home' });
              } else {
                this.isBound = true;
              }
            } else {
              this.$router.replace({ path: '/role-change' });
            }
          }).finally(_ => {
              this.hideLoading();
              this.isFirst = true
            });
      }
    },
    prevent_back() {
      let path = this.$route.fullPath;
      // 判断是否开启了后端支持
      if (this.$router.mode == "hash") {
        path = "#" + path;
      }
      window.pushStateFun = function () {
        let state = {
          title: null,
          url: path, //要禁掉的页面
        };
        /* 
					三个参数：
					state：一个与指定网址相关的状态对象，popstate事件触发时，该对象会传入回调函数。如果不需要这个对象，此处可以填null。
					title：新页面的标题，但是所有浏览器目前都忽略这个值，因此这里可以填null。
					url：新的网址，必须与当前页面处在同一个域。浏览器的地址栏将显示这个网址。
				*/
        window.history.pushState(state, null, path); //要禁掉的页面
      };
      var state = {
        title: null,
        url: path, //要禁掉的页面
      };
      window.history.pushState(state, null, path); //要禁掉的页面
      window.addEventListener("popstate", window.pushStateFun, false);
    },
  },
  activated(){
    this.prevent_back();
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("popstate", window.pushStateFun, false);
    next();
  }
}
</script>

<style lang="stylus" scoped>
.content
  height 100vh
  overflow hidden
  background-color: #fff
  .form-box
    padding 15px
    .left-icon-box
      position relative
      top 2px
      margin-right 8px
      width 22px
      height: 24px
      >img
        width 100%
        height: auto

    .input-left-icon
      line-height 33px
      // margin-right 15px
    .input-left-icon1
      // margin-right 15px
    .code-btn
      padding 0
      border none
      height: 24px
      line-height 24px
      font-size 14px
  .btn-box
    margin 20px 16px 
  .tips-content
    color #777
    font-size 12px
    line-height 18px
  .block-btn
    border-radius: 25px
    font-size 16px
    color #FFF
    background linear-gradient(#FF8820, #FF6B31)

  .success-box
    padding 15px
    .info-box
      padding 15px 0
      text-align: center
      >div
        margin-top 15px
</style>